import { getOrderStatisticsPrimaryPhase } from '../../statistics/charts/pipeline/lib/orderPrimaryPhaseConfig';
import {
	ORDER_PRIMARY_PHASE_LINE_ITEM_DIMENSIONS,
	resolveOrderDimensionKey,
	resolveOrderLineItemDimensionBuckets,
} from '../../statistics/charts/pipeline/lib/orderPrimaryPhaseDimension';
import { resolveProvinceMapNameFromCityCode } from '../../statistics/charts/pipeline/lib/orderPrimaryPhaseGeoBuckets';
import { getOrderDeliveryStatusLabel } from '../../../utils/order/orderDeliveryStatusDisplay';
import { getOrderListPaymentStatusLabel } from '../../../utils/order/orderListStatusFilterOptions';
import { ORDER_APPROVAL_STATUS_LABELS } from '../../../utils/order/orderStatus';

const resolveStatusLabel = (field, rawValue) => {
	if (field === 'approvalStatus') return ORDER_APPROVAL_STATUS_LABELS[rawValue] ?? rawValue ?? '未知';
	if (field === 'paymentStatus') return getOrderListPaymentStatusLabel(rawValue);
	if (field === 'deliveryStatus') return getOrderDeliveryStatusLabel(rawValue);
	return rawValue ?? '未知';
};

export const filterLivePresetDrillOrders = (orders = [], drill = null) => {
	const list = Array.isArray(orders) ? orders : [];
	if (!drill) return list;

	return list.filter((order) => {
		if (drill.kind === 'phase' && drill.phase) {
			if (getOrderStatisticsPrimaryPhase(order) !== drill.phase) return false;
			return true;
		}

		if (drill.kind === 'status' && drill.field) {
			const rawValue = order?.[drill.field] ?? '';
			if (drill.rawValue != null && drill.rawValue !== '') {
				return String(rawValue) === String(drill.rawValue);
			}
			if (drill.label) {
				return resolveStatusLabel(drill.field, rawValue) === drill.label;
			}
			return true;
		}

		if (drill.kind === 'dimension' && drill.dimension && drill.dimensionKey) {
			if (ORDER_PRIMARY_PHASE_LINE_ITEM_DIMENSIONS.has(drill.dimension)) {
				return resolveOrderLineItemDimensionBuckets(order, drill.dimension).some((bucket) => bucket.key === drill.dimensionKey);
			}
			return resolveOrderDimensionKey(order, drill.dimension) === drill.dimensionKey;
		}

		if (drill.kind === 'overdue') {
			const ids = new Set((drill.orderIds ?? []).map(String).filter(Boolean));
			if (!ids.size) return false;
			return ids.has(String(order?._id ?? '')) || ids.has(String(order?.orderId ?? ''));
		}

		if (drill.kind === 'geo') {
			const cityCode = String(order?.customerCity ?? order?.customerCityCode ?? order?.customerInfo?.cityCode ?? '').trim();
			if (drill.cityCode) {
				return cityCode === String(drill.cityCode);
			}
			if (drill.provinceName) {
				if (/^\d{6}$/.test(cityCode)) {
					return resolveProvinceMapNameFromCityCode(cityCode) === drill.provinceName;
				}
				const province = order?.customerProvince ?? order?.customerInfo?.province ?? '';
				return province === drill.provinceName;
			}
			return false;
		}

		return false;
	});
};

export default filterLivePresetDrillOrders;
